import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const eventsAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = eventsAdapter.getInitialState()

export const eventsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getEvents: builder.query({
            query: ({ page = 1, search = '', date = '', category = '' }) => {
                const params = new URLSearchParams();
                params.append('page', page.toString());
                if (search) params.append('search', search);
                if (date) params.append('date', date);
                if (category) params.append('category', category);
                return {
                    url: `/api/v1/events?${params.toString()}`,
                    method: 'GET',
                };
            },
            transformResponse: responseData => {
                const data = responseData.result || []
                const loadedEvents = data.map(event => {
                    event.id = event._id
                    return event
                })
                return eventsAdapter.setAll(initialState, loadedEvents)
            },
            providesTags: (result) =>
                result?.ids
                    ? [
                        { type: 'Event', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Event', id }))
                    ]
                    : [{ type: 'Event', id: 'LIST' }]
        }),

        addNewEvent: builder.mutation({
            query: (formData) => ({
                url: '/api/v1/events/create-event',
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: [
                { type: 'Event', id: "LIST" }
            ]
        }),
        updateEvent: builder.mutation({
            query: initialEvent => ({
                url: '/api/v1/events/update',
                method: 'PATCH',
                body: initialEvent,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Event', id: arg.get('id') }
            ]
        }),
        deleteEvent: builder.mutation({
            query: ({ id }) => ({
                url: `/api/v1/events/delete`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Event', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetEventsQuery,
    useAddNewEventMutation,
    useUpdateEventMutation,
    useDeleteEventMutation,
} = eventsApiSlice

// returns the query result object
export const selectEventsResult = eventsApiSlice.endpoints.getEvents.select()

// creates memoized selector
const selectEventsData = createSelector(
    selectEventsResult,
    eventsResult => eventsResult.data
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllEvents,
    selectById: selectEventById,
    selectIds: selectEventIds
} = eventsAdapter.getSelectors(state => selectEventsData(state) ?? initialState)